import React from 'react';
import { styles } from '../../styles';

interface ChartTabProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Simple chart tab wrapper - just provides spacing and card layout
 * All subtab logic should be handled inside the chart component
 */
const ChartTab: React.FC<ChartTabProps> = ({ children, className = '' }) => {
  return (
    <div className="space-y-4">
      <div className={`${styles.card.chart} ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default ChartTab;
